import {
  createFileRoute,
} from '@tanstack/react-router';

import {
  resolveObject,
} from '@specia-accountant/shared';

import {
  ClientBulkEdit,
} from '#src/features/client/ClientBulkEdit';
import {
  type ClientWithId,
} from '#src/features/client/Client.schema';

export const Route = createFileRoute('/_app/_authenticated/settings/clients')({
  loader: async (opts) => {
    const clients = opts.context.queryClient.ensureQueryData({
      queryKey: [
        'reporter',
        'admin',
        'clients',
      ],
    }) satisfies Promise<ClientWithId[]>;
    return resolveObject({
      clients,
    });
  },
  component: RouteComponent,
});

function RouteComponent() {
  const {
    clients,
  } = Route.useLoaderData();
  return (
    <>
      <ClientBulkEdit
        clients={ clients }
      />
    </>
  );
}
